/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_State_LabelInputs */

const en_explorer_thumbnail_state_label = /** @type {(inputs: Explorer_Thumbnail_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`State:`)
};

const fr_explorer_thumbnail_state_label = /** @type {(inputs: Explorer_Thumbnail_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etat :`)
};

const de_explorer_thumbnail_state_label = /** @type {(inputs: Explorer_Thumbnail_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zustand:`)
};

const it_explorer_thumbnail_state_label = /** @type {(inputs: Explorer_Thumbnail_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stato:`)
};

const ru_explorer_thumbnail_state_label = /** @type {(inputs: Explorer_Thumbnail_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Состояние:`)
};

const es_explorer_thumbnail_state_label = /** @type {(inputs: Explorer_Thumbnail_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado:`)
};

const zh_cn2_explorer_thumbnail_state_label = /** @type {(inputs: Explorer_Thumbnail_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状态：`)
};

const ja_explorer_thumbnail_state_label = /** @type {(inputs: Explorer_Thumbnail_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`州：`)
};

const hi_explorer_thumbnail_state_label = /** @type {(inputs: Explorer_Thumbnail_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`राज्य:`)
};

const pt_pt2_explorer_thumbnail_state_label = /** @type {(inputs: Explorer_Thumbnail_State_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado:`)
};

/**
* | output |
* | --- |
* | "State:" |
*
* @param {Explorer_Thumbnail_State_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_state_label = /** @type {((inputs?: Explorer_Thumbnail_State_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_State_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_thumbnail_state_label(inputs)
	if (locale === "de") return de_explorer_thumbnail_state_label(inputs)
	if (locale === "it") return it_explorer_thumbnail_state_label(inputs)
	if (locale === "ru") return ru_explorer_thumbnail_state_label(inputs)
	if (locale === "es") return es_explorer_thumbnail_state_label(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_thumbnail_state_label(inputs)
	if (locale === "ja") return ja_explorer_thumbnail_state_label(inputs)
	if (locale === "hi") return hi_explorer_thumbnail_state_label(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_thumbnail_state_label(inputs)
	return en_explorer_thumbnail_state_label(inputs)
});